import { useFormContext } from 'react-hook-form';
import { OfferModalForm } from './types';

const useOfferModalFormContext = () => {
  return useFormContext<OfferModalForm>();
};

export default useOfferModalFormContext;
